import { ListOfCity } from "../ListOfCity"
import { ListOfEventAchiever } from "../ListOfEventAchiever"


export const dataDiamond = [
    {
        name: "Abigail Caitlyn Electra",
        country: ListOfCity.SMR,
        YoutubeLink: "https://www.youtube.com/watch?v=sijinYGOZnw&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2024APCSCLASSIC"], ListOfEventAchiever["2023CHRISTMAS"]]
    },
    {
        name: "Abigail Kimberly Indrajaya",
        country: ListOfCity.PLB,
        YoutubeLink: "https://www.youtube.com/watch?v=sijinYGOZnw&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        name: "Adeleine Angelique Wiryanto",
        country: ListOfCity.SRB,
        YoutubeLink: "https://www.youtube.com/watch?v=1R0mf-yRRB8&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CHRISTMAS"]]
    },
    {
        name: "Ann Shereen Yao",
        country: ListOfCity.JKT,
        YoutubeLink: "https://www.youtube.com/watch?v=779gXnPTs-0&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CHRISTMAS"], ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Alf Elijah Beloved Sigarlaki",
        country: ListOfCity.JKT,
        YoutubeLink: "https://www.youtube.com/watch?v=9iMrg1T1p_w&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2022MAGICMUSIC"], ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Allegra Alcira Foo Ing Yue",
        country: ListOfCity.TNG,
        YoutubeLink: "https://www.youtube.com/watch?v=h9jRMGO66mA&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CLASSICJKT"], ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        name: "Ashley Michelle Poh",
        country: ListOfCity.TNG,
        YoutubeLink: "https://www.youtube.com/watch?v=6DkCJVJPjsQ&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Athanasius Warren Jonatan",
        country: ListOfCity.JKT,
        YoutubeLink: "https://www.youtube.com/watch?v=-EwR6Gkue9s&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2024APCSCLASSIC"], ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Ann Shereen Yao & Adrianne Shanelle Yao",
        country: ListOfCity.JKT,
        YoutubeLink: "https://www.youtube.com/watch?v=779gXnPTs-0&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2022MAGICMUSIC"], ListOfEventAchiever["2023CHRISTMAS"], ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Arissa Eillin Budiono",
        country: ListOfCity.PLB,
        YoutubeLink: "https://www.youtube.com/watch?v=-p6JIOod6_c&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2024APCSCLASSIC"], ListOfEventAchiever["2023CHRISTMAS"], ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        name: "Ashton Micah Poh",
        country: ListOfCity.TNG,
        YoutubeLink: "https://www.youtube.com/watch?v=UH8J4olztEo&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CHRISTMAS"], ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Philia Eltan Haryanto & Brigitta Gracelyn Thetrasakti",
        country: ListOfCity.JKT,
        YoutubeLink: "https://www.youtube.com/watch?v=FF3aXBHffbw&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CHRISTMAS"]]
    },
    {
        name: "Britanny Charlene Liaunardy",
        country: ListOfCity.SRB,
        YoutubeLink: "https://www.youtube.com/watch?v=bHUYL-i0KIc&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CHRISTMAS"]]
    },
    {
        name: "Bryan Immanuel Gunawan",
        country: ListOfCity.SRB,
        YoutubeLink: "https://www.youtube.com/watch?v=3R4niYXPdSg&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CHRISTMAS"]]
    },
    {
        name: "Cathleen Scarlett Hayasi",
        country: ListOfCity.JKT,
        YoutubeLink: "https://www.youtube.com/watch?v=D1ct_m0XJtY&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2024APCSCLASSIC"], ListOfEventAchiever["2022MAGICMUSIC"], ListOfEventAchiever["2023CHRISTMAS"], ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Clarissa Stefanny",
        country: ListOfCity.PNT,
        YoutubeLink: "https://www.youtube.com/watch?v=XR8yYVUsBzo&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CHRISTMAS"], ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Edward Nathaniel Handoko",
        country: ListOfCity.SRB,
        YoutubeLink: "https://www.youtube.com/watch?v=twdiVI7WYNA&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CHRISTMAS"], ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        name: "Gizelle Everly Wantana",
        country: ListOfCity.JKT,
        YoutubeLink: "https://www.youtube.com/watch?v=pSzly_St6yY&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2024APCSCLASSIC"], ListOfEventAchiever["2023CHRISTMAS"]]
    },
    {
        name: "Joane Gabriella Ianputri & Josephine Mulyani",
        country: ListOfCity.JKT,
        YoutubeLink: "https://www.youtube.com/watch?v=54HLINLr4Xs&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CHRISTMAS"]]
    },
    {
        name: "Kayla Calista Ayal",
        country: ListOfCity.BGR,
        YoutubeLink: "https://www.youtube.com/watch?v=oivwx12q0Do&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2022MAGICMUSIC"], ListOfEventAchiever["2023CHRISTMAS"]]
    },
    {
        name: "Keenan Kwok",
        country: ListOfCity.JKT,
        YoutubeLink: "https://www.youtube.com/watch?v=MRbkf3Jlm9I&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CHRISTMAS"], ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        name: "Madelynn Esmee Theodore",
        country: ListOfCity.SRB,
        YoutubeLink: "https://www.youtube.com/watch?v=7WAlZEqbdZ8&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2024APCSCLASSIC"], ListOfEventAchiever["2023CHRISTMAS"]]
    },
    {
        name: "Mary Kate Onggowijoyo",
        country: ListOfCity.SRB,
        YoutubeLink: "https://www.youtube.com/watch?v=J5UZM0lH0Cc&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2022MAGICMUSIC"], ListOfEventAchiever["2023CHRISTMAS"], ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        name: "Reinhart Avery Hidayat",
        country: "Lampung",
        YoutubeLink: "https://www.youtube.com/watch?v=orBGO3n5TzM&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CHRISTMAS"]]
    },
    {
        name: "Sekar Pituwas Katresnan",
        country: "Magelang",
        YoutubeLink: "https://www.youtube.com/watch?v=5gCfm1y91x4&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CHRISTMAS"]]
    },
    {
        name: "Shannon Richelle Johannanto",
        country: "Semarang",
        YoutubeLink: "https://www.youtube.com/watch?v=KBymvNeAFIc&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2024APCSCLASSIC"], ListOfEventAchiever["2023CHRISTMAS"]]
    },
    {
        name: "Sheera Lie Susanto",
        country: "Semarang",
        YoutubeLink: "-",
        event: [ListOfEventAchiever["2023CHRISTMAS"]]
    },
    {
        name: "Skyler Frensi Lie",
        country: ListOfCity.JKT,
        YoutubeLink: "-",
        event: [ListOfEventAchiever["2024APCSCLASSIC"], ListOfEventAchiever["2023CHRISTMAS"]]
    },
    {
        name: "Stela Lie Susanto",
        country: "Semarang",
        YoutubeLink: "-",
        event: [ListOfEventAchiever["2023CHRISTMAS"]]
    },
    {
        name: "Renata Mia Guntoro",
        country: ListOfCity.JKT,
        YoutubeLink: "https://www.youtube.com/watch?v=1HIPpWh5-cs&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CHRISTMAS"]]
    },
    {
        name: "Vanessa Hardianto",
        country: ListOfCity.TNG,
        YoutubeLink: "https://www.youtube.com/watch?v=ha4YHiPchII&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CHRISTMAS"], ListOfEventAchiever["2023CLASSICSRBY"]]
    },


    {
        name: "Calvin Yoel Pandiangan",
        country: ListOfCity.BTM,
        YoutubeLink: "",
        event: [ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Calya Anara Wijaya",
        country: ListOfCity.JKT,
        YoutubeLink: "https://www.youtube.com/watch?v=F1kpOEjWYQg&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2024APCSCLASSIC"], ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Cheryn Pandora & Edenia Maureen",
        country: ListOfCity.SRB,
        YoutubeLink: "",
        event: [ListOfEventAchiever["2024APCSCLASSIC"], ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Chyra Yemima Ekaputra",
        country: ListOfCity.BKS,
        YoutubeLink: "",
        event: [ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Claire Abigail Quinn",
        country: ListOfCity.JKT,
        YoutubeLink: "https://www.youtube.com/watch?v=nPGdTzNX_Mk&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Claire Hartono",
        country: ListOfCity.JKT,
        YoutubeLink: "https://www.youtube.com/watch?v=mxSDoydDj6g&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2024APCSCLASSIC"], ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Clayton Oliver Hayasi",
        country: ListOfCity.JKT,
        YoutubeLink: "https://www.youtube.com/watch?v=Fke-4LVyGno&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2024APCSCLASSIC"], ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Clayton Oliver Hayasi & Cathleen Scarlett Hayasi",
        country: ListOfCity.JKT,
        YoutubeLink: "https://www.youtube.com/watch?v=Fke-4LVyGno&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        name: "Fadlasyah Rifqy",
        country: ListOfCity.JKT,
        YoutubeLink: "https://www.youtube.com/watch?v=0Ye5ydaInZw&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Gregorius Reinhardt",
        country: ListOfCity.PLB,
        YoutubeLink: "https://www.youtube.com/watch?v=TntCfGmzFSU&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2022MAGICMUSIC"], ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Hazel Everly Wantana",
        country: ListOfCity.JKT,
        YoutubeLink: "https://www.youtube.com/watch?v=Hn6OZoc9ujU&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2022MAGICMUSIC"], ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Yuniasri Maya Aisyah & Ike Kusumawati",
        country: "Semarang",
        YoutubeLink: "https://www.youtube.com/watch?v=4TE9K3E9EfI&t=147s&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Iris Araceli Ma",
        country: ListOfCity.SRB,
        YoutubeLink: "https://www.youtube.com/watch?v=KLFuAi6iha0&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2022MAGICMUSIC"], ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Jane Adelene Sun",
        country: ListOfCity.PLB,
        YoutubeLink: "https://www.youtube.com/watch?v=sIfkEaIcPYo&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Janice Bella Kotandi",
        country: ListOfCity.JKT,
        YoutubeLink: "",
        event: [ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Jehoshua Amadeus Samuel Amanta Nainggolan & Florisia Revanya Josephine",
        country: "Yogyakarta",
        YoutubeLink: "https://www.youtube.com/watch?v=2Li-73xu7rI&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Kaleb Yuseli",
        country: ListOfCity.SLT,
        YoutubeLink: "https://www.youtube.com/watch?v=OrQ2tsXxe6o&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Katherine Natalie Mulyadi",
        country: ListOfCity.BGR,
        YoutubeLink: "https://youtu.be/apgUhkXAIVs",
        event: [ListOfEventAchiever["2024APCSCLASSIC"], ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Lawrence Cedric Senjaya",
        country: ListOfCity.BDO,
        YoutubeLink: "https://www.youtube.com/watch?v=hwoE6v6JZXo&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Lionel Vito Wijaya",
        country: ListOfCity.PLB,
        YoutubeLink: "",
        event: [ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Lucius Keenan Raine",
        country: ListOfCity.PLB,
        YoutubeLink: "",
        event: [ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Marshaina Azalia Primatantri & Thirza Maida Alam",
        country: ListOfCity.BGR,
        YoutubeLink: "",
        event: [ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Maryam Almayrha Nugraha",
        country: ListOfCity.JKT,
        YoutubeLink: "",
        event: [ListOfEventAchiever["2024APCSCLASSIC"], ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Nicole Joy Nathan",
        country: ListOfCity.JKT,
        YoutubeLink: "",
        event: [ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Nur Alifah Najjah",
        country: ListOfCity.BKS,
        YoutubeLink: "",
        event: [ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Raphael Zephaniah",
        country: ListOfCity.JKT,
        YoutubeLink: "https://www.youtube.com/watch?v=by5r6BfutJk&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Raphael Zephaniah & Maria Laurencia",
        country: ListOfCity.JKT,
        YoutubeLink: "https://www.youtube.com/watch?v=by5r6BfutJk&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        name: "Sharon Hanrin Christian Chandra",
        country: ListOfCity.JKT,
        YoutubeLink: "https://www.youtube.com/watch?v=RuNUFbKDmME&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        name: "Clara Brigitta Hartono & Sharon Hanrin Christian Chandra",
        country: ListOfCity.JKT,
        YoutubeLink: "https://www.youtube.com/watch?v=RuNUFbKDmME&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Skye Hartono",
        country: ListOfCity.JKT,
        YoutubeLink: "",
        event: [ListOfEventAchiever["2024APCSCLASSIC"], ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Stephanie Gwen Liem",
        country: ListOfCity.JKT,
        YoutubeLink: "https://www.youtube.com/watch?v=uh6gOSspbrs&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2022MAGICMUSIC"], ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Sutra Cahaya Wijaya",
        country: "Pekanbaru",
        YoutubeLink: "https://www.youtube.com/watch?v=PvrwxGl3bic&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Sydney Mikaela Tan",
        country: ListOfCity.TNG,
        YoutubeLink: "https://www.youtube.com/watch?v=gItdcXGQqSM&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CLASSICSRBY"], ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Timothy Sam Kosasih",
        country: ListOfCity.JKT,
        YoutubeLink: "https://www.youtube.com/watch?v=5Fce0KI_NA8&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Vallery Dominic Gunawan",
        country: ListOfCity.JKT,
        YoutubeLink: "",
        event: [ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Victoria Severine Liono",
        country: ListOfCity.JKT,
        YoutubeLink: "",
        event: [ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Woodseed Quintet (Gadang Wahyu Arafah Flute, Braindi Ari Setiawan Oboe, Dwi Adi Kurniawan . French Horn, Azkal Azkiya Bassoon, Sa'id Dwi Santosa Clarinet)",
        country: "Yogyakarta",
        YoutubeLink: "",
        event: [ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        name: "Zoe Kalonice Robin",
        country: ListOfCity.PLB,
        YoutubeLink: "https://www.youtube.com/watch?v=IiagS3bLpKU&ab_channel=APIANOCONCERTOSERIES",
        event: [ListOfEventAchiever["2023CLASSICJKT"]]
    },
    {
        "name": "Allison Gwen Handojo",
        "country": ListOfCity.SRB,
        "YoutubeLink": "https://www.youtube.com/watch?v=tnI0gfy9xjA&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        "name": "Cathelyn Hanna Gunawan",
        "country": ListOfCity.SRB,
        "YoutubeLink": "https://www.youtube.com/watch?v=X0D3ptqYy24&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        "name": "Cheryl Pandora",
        "country": ListOfCity.MD,
        "YoutubeLink": "https://www.youtube.com/watch?v=XFvWVT0Wroc&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        "name": "Dionisius Gilbert Hartono",
        "country": ListOfCity.PLB,
        "YoutubeLink": "-",
        "event": [ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        "name": "Isabel Arwen Kurniawan",
        "country": ListOfCity.PNT,
        "YoutubeLink": "https://www.youtube.com/watch?v=fuSYMwZtjtY&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        "name": "Jacqueline Harianto & Evangelica Dinamita Rut Hutahaean",
        "country": ListOfCity.TNG,
        "YoutubeLink": "https://www.youtube.com/watch?v=Z4_fBoPJAKM&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        "name": "Jeffren Leliga",
        "country": ListOfCity.SRB,
        "YoutubeLink": "https://www.youtube.com/watch?v=bMBKgEL4x3w&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2022MAGICMUSIC"], ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        "name": "Jennise Tiana Suwono",
        "country": ListOfCity.SRB,
        "YoutubeLink": "https://www.youtube.com/watch?v=LIT9VMex_i8&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        "name": "Joan Annette",
        "country": ListOfCity.SRB,
        "YoutubeLink": "https://www.youtube.com/watch?v=vE8jRWMotBM&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        "name": "Jocelyn Joeyvancha Gan",
        "country": ListOfCity.SRB,
        "YoutubeLink": "https://www.youtube.com/watch?v=E7fNnydSPHA&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        "name": "Jordan Eli Santoso",
        "country": ListOfCity.JKT,
        "YoutubeLink": "https://www.youtube.com/watch?v=x1A-bb3hh4I&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"], ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        "name": "Joshua Kevin Hudyana",
        "country": ListOfCity.SRB,
        "YoutubeLink": "https://www.youtube.com/watch?v=JDU_q_ZjfW0&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        "name": "Juan Hubert Huang",
        "country": ListOfCity.MDN,
        "YoutubeLink": "https://www.youtube.com/watch?v=bDLSB0Osliw&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        "name": "Kate Simmons",
        "country": ListOfCity.SRB,
        "YoutubeLink": "https://www.youtube.com/watch?v=s5CRH-7MWP0&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        "name": "Michael Phillipe Andree & Graziella Jasmine Lovell",
        "country": ListOfCity.SRB,
        "YoutubeLink": "-",
        "event": [ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        "name": "Michael Phillipe Andree",
        "country": ListOfCity.SRB,
        "YoutubeLink": "https://www.youtube.com/watch?v=9Xgu6PLNNg0&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"], ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        "name": "Michelle Aileen Harjarudra",
        "country": ListOfCity.SRB,
        "YoutubeLink": "-",
        "event": [ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        "name": "Mikayla Wirawan",
        "country": ListOfCity.SID,
        "YoutubeLink": "https://www.youtube.com/watch?v=zNRcY64OEH4&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        "name": "Minka Corine Lim",
        "country": ListOfCity.SRB,
        "YoutubeLink": "https://www.youtube.com/watch?v=mN_e9ls3zis&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        "name": "Pauline Lim",
        "country": ListOfCity.PLB,
        "YoutubeLink": "-",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"], ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        "name": "Reyna Gratia Ivanka",
        "country": ListOfCity.KDS,
        "YoutubeLink": "https://www.youtube.com/watch?v=p1a5mKD6StE&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        "name": "Rheine Yessa Siregar",
        "country": ListOfCity.JKT,
        "YoutubeLink": "https://www.youtube.com/watch?v=hlYQbi2_rDY&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        "name": "Sean Kenneth Hudyana",
        "country": ListOfCity.BLR,
        "YoutubeLink": "https://www.youtube.com/watch?v=hlYQbi2_rDY&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        "name": "Shelley Jovanca",
        "country": ListOfCity.SRB,
        "YoutubeLink": "-",
        "event": [ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        "name": "Sinclair Justin Gohandi",
        "country": ListOfCity.SRB,
        "YoutubeLink": "https://www.youtube.com/watch?v=qHdWA7y4Z38&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        "name": "Warren Newton Ma",
        "country": ListOfCity.SRB,
        "YoutubeLink": "https://www.youtube.com/watch?v=VJ9BM1O4EwI&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        "name": "Winston Lawrence Wattimena",
        "country": ListOfCity.SRB,
        "YoutubeLink": "https://www.youtube.com/watch?v=QbVIU4lYSWQ&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2023CLASSICSRBY"]]
    },
    {
        "name": "Azzarine Ishana Syailendra",
        "country": ListOfCity.SRB,
        "YoutubeLink": "-",
        "event": [ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Callista Kertalesmana",
        "country": ListOfCity.JKT,
        "YoutubeLink": "-",
        "event": [ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Celine Gabriella Amijaya",
        "country": ListOfCity.SMR,
        "YoutubeLink": "https://www.youtube.com/watch?v=ABfhBsL9dpw&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"], ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Celine Lie",
        "country": ListOfCity.JKT,
        "YoutubeLink": "https://www.youtube.com/watch?v=glmCvkRxmWA&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Charice Elleanore Konggo Budiman",
        "country": ListOfCity.SRB,
        "YoutubeLink": "https://www.youtube.com/watch?v=NewtKsNhs_4&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"], ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Eunike Alexandra Winoto",
        "country": ListOfCity.SRB,
        "YoutubeLink": "https://www.youtube.com/watch?v=8seYe3404cg&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Fiona Lynn Sie",
        "country": ListOfCity.SMR,
        "YoutubeLink": "https://www.youtube.com/watch?v=jwQk6n4h144&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Gweneth Clarabel",
        "country": ListOfCity.SRB,
        "YoutubeLink": "https://www.youtube.com/watch?v=ukKL2rVILx4&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Gwyneth Madeline Liechelle Fanto & Melodi Tirza",
        "country": ListOfCity.YKT,
        "YoutubeLink": "https://www.youtube.com/watch?v=Mdqj3pjkQwc&ab_channel=APIANOCONCERTOSERIESS",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"], ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Inez Indriani",
        "country": ListOfCity.BDO,
        "YoutubeLink": "https://www.youtube.com/watch?v=_13HZYyGYlQ&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Isabella Anjani & Aurellia Margareth William",
        "country": ListOfCity.TNG,
        "YoutubeLink": "https://www.youtube.com/watch?v=jtJdj4SPqRY&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Jaden William Tang",
        "country": ListOfCity.PLB,
        "YoutubeLink": "https://www.youtube.com/watch?v=U4ewR5bJwKA&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Joline Jati Utomo",
        "country": ListOfCity.SMR,
        "YoutubeLink": "https://www.youtube.com/watch?v=A8Bp1880zf4&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Kani Kalavati",
        "country": ListOfCity.DPK,
        "YoutubeLink": "https://www.youtube.com/watch?v=UgJooW0GCzE&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Kaylee Adrienne Gunawan",
        "country": ListOfCity.SRB,
        "YoutubeLink": "https://www.youtube.com/watch?v=i2EGEu7VFVg&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Lougan Steinson Wiranto",
        "country": ListOfCity.SMR,
        "YoutubeLink": "https://www.youtube.com/watch?v=lApJUHVGVrw&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Ludwina Natasya Azarine & Natasha Julia Budiarjo",
        "country": ListOfCity.SMR,
        "YoutubeLink": "https://www.youtube.com/watch?v=-K51m8NSZgA&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Megan Magdalene Liem",
        "country": ListOfCity.SMR,
        "YoutubeLink": "https://www.youtube.com/watch?v=ca8KN0xYBtg&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Michelle Natalie Setiabudi",
        "country": ListOfCity.JKT,
        "YoutubeLink": "https://www.youtube.com/watch?v=JlNUsFCzNF4&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Nadia Putri Bharata",
        "country": ListOfCity.SMR,
        "YoutubeLink": "https://www.youtube.com/watch?v=lsXM2WxNZvA&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Peter Frey Widjaja",
        "country": ListOfCity.SMR,
        "YoutubeLink": "https://www.youtube.com/watch?v=TZXlegYqovQ&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Putri Birru Shafa",
        "country": ListOfCity.TNG,
        "YoutubeLink": "https://www.youtube.com/watch?v=7rKG-ngmX7g&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Rehuel Aurelius Ethan Sitompul",
        "country": ListOfCity.MD,
        "YoutubeLink": "https://www.youtube.com/watch?v=AMQsmLyiQrk&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Reina Merielle Then",
        "country": ListOfCity.TNG,
        "YoutubeLink": "https://www.youtube.com/watch?v=6dwob3zxOIo&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Sam Joseph Arthur",
        "country": ListOfCity.SMR,
        "YoutubeLink": "https://www.youtube.com/watch?v=f5__60AfXpU&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"], ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Sidney Loo",
        "country": ListOfCity.SRB,
        "YoutubeLink": "https://www.youtube.com/watch?v=FVlBEjVP4dw&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Sukent",
        "country": ListOfCity.MD,
        "YoutubeLink": "https://www.youtube.com/watch?v=31LgHy1J3cI&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Tabita Indri N & Pramita Dwinovianti J",
        "country": ListOfCity.SMR,
        "YoutubeLink": "https://www.youtube.com/watch?v=QIxGekVqrsc&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Victoria Inverness Susilo",
        "country": ListOfCity.SRB,
        "YoutubeLink": "https://www.youtube.com/watch?v=IZDGCKn9-y4&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Andrew Jevera Tan",
        "country": ListOfCity.TNG,
        "YoutubeLink": "https://www.youtube.com/watch?v=R_Cju-VofH4&ab_channel=APIANOCONCERTOSERIES",
        "event": [ListOfEventAchiever["2022MAGICMUSIC"]]
    },
    {
        "name": "Miguela Naraya Ng",
        "image": "dummyimage",
        "country": ListOfCity.JKT,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Charlotte Theodora Chia",
        "image": "dummyimage",
        "country": ListOfCity.JKT,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Sharlyn Chandra",
        "image": "dummyimage",
        "country": ListOfCity.SRB,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "William Anthony Mulyadi",
        "image": "dummyimage",
        "country": "Bogor",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Chloe Sinjaya",
        "image": "dummyimage",
        "country": "Medan",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Louis Mclawrence Hendra",
        "image": "dummyimage",
        "country": ListOfCity.JKT,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Ong Yu Xuan Alyssa",
        "image": "dummyimage",
        "country": "Singapore",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Austin Aldrich Tirta",
        "image": "dummyimage",
        "country": ListOfCity.JKT,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Candyce Eudora Oung ",
        "image": "dummyimage",
        "country": "Medan",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Wilson Anthony Mulyadi",
        "image": "dummyimage",
        "country": "Bogor",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Darlene Manuella Gani",
        "image": "dummyimage",
        "country": ListOfCity.SRB,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Russell Nathan Indrali",
        "image": "dummyimage",
        "country": ListOfCity.JKT,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Freya Venezia Bong ",
        "image": "dummyimage",
        "country": ListOfCity.SRB,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Dominic Joel Wijaya",
        "image": "dummyimage",
        "country": ListOfCity.JKT,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Leticya Caithlynn Phanjaya",
        "image": "dummyimage",
        "country": "Solo",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Candice Chloe King",
        "image": "dummyimage",
        "country": "Medan",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Carissa Faith Anggana",
        "image": "dummyimage",
        "country": ListOfCity.JKT,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "KARIN MICHIKO PANGESTOE",
        "image": "dummyimage",
        "country": "Tangerang",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Michael Sudianto",
        "image": "dummyimage",
        "country": "Medan",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Elliot Tjendra",
        "image": "dummyimage",
        "country": "Medan",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Abigail Angelica Santoso",
        "image": "dummyimage",
        "country": "Solo",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Rachel Nathania Suyanto",
        "image": "dummyimage",
        "country": ListOfCity.JKT,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Gabriella Kezia Rosalind",
        "image": "dummyimage",
        "country": "Tangerang",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Phoebe Fleur Widjaja",
        "image": "dummyimage",
        "country": "Semarang",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Darlene Liman",
        "image": "dummyimage",
        "country": ListOfCity.SRB,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Jasmine Isabel Pesik",
        "image": "dummyimage",
        "country": "Tangerang",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Kamala Kilau Pelangi",
        "image": "dummyimage",
        "country": "Semarang",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Lennart Joshua Sugih",
        "image": "dummyimage",
        "country": "Surakarta",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Clarisse Faith Hariyadi",
        "image": "dummyimage",
        "country": ListOfCity.JKT,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Leticia Mikhaela Amijaya",
        "image": "dummyimage",
        "country": "Semarang",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Audi Winter Lee & Cherry Carissa Ho",
        "image": "dummyimage",
        "country": ListOfCity.JKT,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Louise Michelle Emerald Joseph",
        "image": "dummyimage",
        "country": "Semarang",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Annabelle Samuela Ng",
        "image": "dummyimage",
        "country": "Tangerang",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Jovie Peng",
        "image": "dummyimage",
        "country": "Pontianak",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Braelynn Love Suryaatmadja",
        "image": "dummyimage",
        "country": "Semarang",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Cherry Carissa Ho",
        "image": "dummyimage",
        "country": ListOfCity.JKT,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Audi Winter Lee",
        "image": "dummyimage",
        "country": ListOfCity.JKT,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Khellse Valerine",
        "image": "dummyimage",
        "country": "Medan",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Vanessa Christy Kurniawan",
        "image": "dummyimage",
        "country": "Semarang",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Joline Abigail Iskandar",
        "image": "dummyimage",
        "country": ListOfCity.SRB,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Keiko Sheravine Cen",
        "image": "dummyimage",
        "country": "Medan",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Shane Keegan Cen",
        "image": "dummyimage",
        "country": "Medan",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Naomi Thelma",
        "image": "dummyimage",
        "country": "Medan",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Naomi Kaitlyn",
        "image": "dummyimage",
        "country": "Medan",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Floriana Hoei",
        "image": "dummyimage",
        "country": "Tangerang",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Milka Kalyana Setiawan",
        "image": "dummyimage",
        "country": "Tangerang",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Kimberly Della Sophie Hutapea ",
        "image": "dummyimage",
        "country": "Tangerang",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Rachel Untoro",
        "image": "dummyimage",
        "country": ListOfCity.JKT,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Lionel Nathan Wijaya ",
        "image": "dummyimage",
        "country": "Tangerang",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Jocelyn Angelica Wicaksono",
        "image": "dummyimage",
        "country": "Semarang",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Keiko William",
        "image": "dummyimage",
        "country": "Tangerang",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Charlene Ariana Sukri",
        "image": "dummyimage",
        "country": ListOfCity.JKT,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Prapta Dimatteo Pratama",
        "image": "dummyimage",
        "country": ListOfCity.JKT,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Leonard Sterling Tanoko",
        "image": "dummyimage",
        "country": "Malang",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Kenzo Lionel Hendry",
        "image": "dummyimage",
        "country": "Palembang",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Valerie Edyana Wibianto",
        "image": "dummyimage",
        "country": "Medan",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Jonathan Sugiharto Iskandar",
        "image": "dummyimage",
        "country": ListOfCity.JKT,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Ritchie Jaimeson Kowara",
        "image": "dummyimage",
        "country": "Palembang",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Audrey Winna Yohan",
        "image": "dummyimage",
        "country": "Medan",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Jorge Amadeo Benavides",
        "image": "dummyimage",
        "country": "Surakarta",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Jelica Angelline Zecy Yang",
        "image": "dummyimage",
        "country": "Jambi",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Cleo Alexis Sudarman",
        "image": "dummyimage",
        "country": "Medan",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Maximus Huang Tirtawigoena ",
        "image": "dummyimage",
        "country": ListOfCity.JKT,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Catherine Emilianna Chahyadi",
        "image": "dummyimage",
        "country": "Medan",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Alberta Debora Alva Kambuno ",
        "image": "dummyimage",
        "country": ListOfCity.JKT,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Carole Valerie Gunawan",
        "image": "dummyimage",
        "country": ListOfCity.SRB,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Claire Audrey Sudarman",
        "image": "dummyimage",
        "country": "Medan",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Serene Patricia",
        "image": "dummyimage",
        "country": ListOfCity.SRB,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Marta Liauw",
        "image": "dummyimage",
        "country": ListOfCity.JKT,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Domi Satria",
        "image": "dummyimage",
        "country": "Yogyakarta",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Clarissa Abigail Pradana",
        "image": "dummyimage",
        "country": "Bali",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Meghan Alisa Wu",
        "image": "dummyimage",
        "country": "Bali",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Kanaya Namirah Cetta",
        "image": "dummyimage",
        "country": "Palembang",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Chelsea Joanna Setiawan",
        "image": "dummyimage",
        "country": "Yogyakarta",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Parrish Lim",
        "image": "dummyimage",
        "country": "Palembang",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "GWYNETH ALICIA PRADANA",
        "image": "dummyimage",
        "country": "Bali",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Afonso Rufino Abilio de Araujo",
        "image": "dummyimage",
        "country": "Jkt",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Jocelyn Gabrielle Alexander",
        "image": "dummyimage",
        "country": "Palembang",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Gwyneth Madeline Liechelle Fanto",
        "image": "dummyimage",
        "country": "Yogyakarta",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Josephine Gabrielle Alexander",
        "image": "dummyimage",
        "country": "Palembang",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Gwen Sabriela Nugroho",
        "image": "dummyimage",
        "country": "Yogyakarta",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Matthew Joshua Elnathan",
        "image": "dummyimage",
        "country": "Yogyakarta",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Nataren Velice ",
        "image": "dummyimage",
        "country": "Palembang",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Mikaela Devanova Amara Belva",
        "image": "dummyimage",
        "country": "Yogyakarta",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Lorraine Anastasia Salim",
        "image": "dummyimage",
        "country": ListOfCity.JKT,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Giuliana Victoria Santosa",
        "image": "dummyimage",
        "country": "Yogyakarta",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Aurelia Lovely Bessie",
        "image": "dummyimage",
        "country": "Medan",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Maria Olivia Christabel Elnathan",
        "image": "dummyimage",
        "country": "Yogyakarta",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Kabhinawa Luh Cintamani Adyutakara",
        "image": "dummyimage",
        "country": "Yogyakarta",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Cathlyn Pherone Chandra",
        "image": "dummyimage",
        "country": "Palembang",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Matthew Kenzo Alexander",
        "image": "dummyimage",
        "country": "Bali",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Kimberly Rachel Gu",
        "image": "dummyimage",
        "country": "Tangerang",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Cleo Alexis Sudarman & Keiko Sheravine Cen",
        "image": "dummyimage",
        "country": "Medan",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Giselle Naeva Gozali & Michelle Naeva Gozali",
        "image": "dummyimage",
        "country": "Medan",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Elijah Javier Soetanto",
        "image": "dummyimage",
        "country": "Palembang",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Callia Kardiono",
        "image": "dummyimage",
        "country": ListOfCity.JKT,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Emma Joy Soetanto ",
        "image": "dummyimage",
        "country": "Palembang",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Faith Huang",
        "image": "dummyimage",
        "country": ListOfCity.SRB,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Debee Chan",
        "image": "dummyimage",
        "country": "Medan",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Callista Vanesa",
        "image": "dummyimage",
        "country": "Lampung",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Hillary Howie Lymnois",
        "image": "dummyimage",
        "country": "Medan",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Freya Calista Suhandi",
        "image": "dummyimage",
        "country": "Lampung",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Cornelius Carlton Chandra",
        "image": "dummyimage",
        "country": "Medan",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Naomi Thelma & Edward Chandra ",
        "image": "dummyimage",
        "country": "Medan",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Christabel Estelle Oei ",
        "image": "dummyimage",
        "country": "Palembang",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Michelle Sutanto",
        "image": "dummyimage",
        "country": "Pekanbaru",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Jorel Aviello",
        "image": "dummyimage",
        "country": ListOfCity.JKT,
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Trisha Juwono Leung",
        "image": "dummyimage",
        "country": "Pekanbaru",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Hillary Howie Lymnois & Debee Chan",
        "image": "dummyimage",
        "country": "Medan",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
    {
        "name": "Claire Audrey Sudarman & Cornelius Carlton Chandra",
        "image": "dummyimage",
        "country": "Medan",
        "YoutubeLink": "",
        "event": [ListOfEventAchiever["2024APCSCLASSIC"]],
    },
]

